<template>
  <div id="page-user-list">
    <!-- =============================================================================================== -->

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 xl:w-1/4 sm:w-full mb-2">
        <div
          class="vx-card p-5"
          style="overflow: auto"
          :style="isSmallerScreen ? '' : `height: 75vh`"
        >
          <ul class="centerx flex mt-4" v-if="actor.privilege < 6">
            <li>
              <vs-radio v-model="type" vs-value="vehicle" class="mb-3 mr-3"
                >By Vehicle</vs-radio
              >
            </li>
            <li>
              <vs-radio v-model="type" vs-value="user">By User</vs-radio>
            </li>
          </ul>
          <div class="vx-row">
            <table style="width: 100%; margin-left: 3px; margin-right: 3px">
              <tr>
                <td style="width: 80%">
                  <vs-input
                    class="mb-3 m-3"
                    style="width: 92%"
                    v-model="temp_keyword"
                    placeholder="Type and Search..."
                    @keydown="(e) => search_proses(e)"
                  />
                </td>
                <td>
                  <vs-button
                    id="btnSearch"
                    type="border"
                    color="primary"
                    class="mr-2 ml-1 p-2 vs-con-loading__container"
                    @click="search_proses()"
                    >Search</vs-button
                  >
                </td>
              </tr>
            </table>
            <table style="width: 100%; margin-top: -10px; margin-left: 3px">
              <tr>
                <td colspan="2">
                  <v-select
                    :options="searchList"
                    :placeholder="
                      loading
                        ? 'Loading...'
                        : searchList.length > 0
                        ? searchListDefault.label
                        : 'No data found'
                    "
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="keyword"
                    class="mb-3 m-3"
                  >
                    <!-- @search="search" -->
                    <template #no-options>{{ noOptionText }}</template>
                  </v-select>
                </td>
              </tr>
            </table>
          </div>

          <!-- <div class="vx-row" v-else>
            <table style="width: 100%; margin-left: 3px">
              <tr>
                <td>
                  <v-select
                    :options="searchList"
                    @search="search"
                    placeholder="Search..."
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="keyword"
                    class="mb-3 m-3"
                  >
                    <template #no-options>{{ noOptionText }}</template>
                  </v-select>
                </td>
              </tr>
            </table>
          </div> -->

          <vs-row>
            <v-tree
              :topMustExpand="topMustExpand"
              v-if="treeData.length > 0"
              ref="tree"
              @node-select="nodeSelect"
              @node-expand="nodeExpand"
              @node-check="nodechecked"
              :canDeleteRoot="true"
              :data="treeData"
              :draggable="true"
              :multiple="true"
            />
            <p v-else>No Data To Show</p>
          </vs-row>
        </div>
      </div>
      <div class="vx-col w-full lg:w-2/3 xl:w-3/4 sm:w-full">
        <div
          class="vx-card p-3"
          :style="isSmallerScreen ? `height: 82vh` : `height: 75vh`"
        >
          <l-map
            class="map"
            ref="peta"
            :center.sync="map.center"
            :zoom="map.zoom"
            :options="mapOptions"
            style="min-height: 100px"
          >
            <l-control
              position="topright"
              style="margin: 10px"
              v-if="actor.privilege >= 4"
            >
              <vs-button
                id="monitoringMode"
                title="Monitoring Mode"
                style="width: 100%; font-weight: 500; cursor: pointer"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-map"
                class="pl-5 mt-1 vs-con-loading__container"
                @click="monitoringMode"
                >Monitoring Mode</vs-button
              >
            </l-control>

            <l-control-layers position="bottomleft"></l-control-layers>

            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('speed_zone')"
                type="filled"
                :color="show_hide_color.speed_zone"
                title="Show Speed Limit by Zone"
                class="btn_poi"
                ><img
                  src="@/assets/images/file-icons/speed_zone.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.speed_zone
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
              /></vs-button>
            </l-control>
            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('geofence')"
                type="filled"
                :color="show_hide_color.geofence"
                title="Show Geofence"
                class="btn_poi"
                ><img
                  src="@/assets/images/file-icons/geofence.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.geofence
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
              /></vs-button>
            </l-control>

            <l-control
              position="bottomleft"
              style="width: 100%; margin-right: 4%"
            >
              <vs-button
                @click="showPolygone('poi')"
                type="filled"
                :color="show_hide_color.poi"
                :title="'One Click to show All POI \nDouble Click to show All POI Name'"
                class="btn_poi"
              >
                <img
                  src="@/assets/images/file-icons/poi.svg"
                  alt=""
                  width="18"
                  :style="
                    show_hide.poi
                      ? 'filter: invert(100%)'
                      : 'filter: invert(0%)'
                  "
                />
              </vs-button>
            </l-control>

            <!-- <l-control position="bottomleft">
              <vs-button
                color="primary"
                type="border"
                icon="navigation"
                size="medium"
                style="
                  font-weight: 700;
                  border-radius: 50px;
                  padding-top: 15px;
                  padding-bottom: 15px;
                  border: 2px solid #c0c0c0;
                "
                :style="!re_center ? 'background-color: white !important;' : ''"
                @click="reCenter"
                >Re-center</vs-button
              >
            </l-control> -->

            <l-control-polyline-measure
              :options="{ showUnitControl: false }"
              position="topleft"
            />

            <l-control-zoom
              position="bottomright"
              class="zoom-control"
            ></l-control-zoom>

            <l-control-fullscreen
              position="bottomright"
              :options="{
                title: { false: 'Fullscreen', true: 'RegularScreen' }
              }"
            />

            <l-control
              position="bottomright"
              title="Google Map"
              class="example-custom-control2"
            >
              <img
                src="@/assets/images/file-icons/google-maps.png"
                width="30"
                alt="Google Map"
                @click="openGoogleMap"
              />
            </l-control>

            <l-control
              position="topleft"
              class="example-custom-control"
              title="Street View"
              style="cursor: pointer"
            >
              <img
                src="https://img.gps.id/assets/icons/icon_streetview.png"
                width="28"
                alt="Street View"
                @click="streetView"
              />
            </l-control>

            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
              :options="{ maxZoom: 22 }"
            />

            <l-polygon
              v-for="(item, index) in zone_speed.polygon"
              :key="'A' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.speed_zone == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Speed By Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Zone Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Speed Limit</td>
                    <td>{{ item.speed }} Km/h</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>

            <l-polygon
              v-for="(item, index) in geofence.polygon_in"
              :key="'IN' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.geofence == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Geofence Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Geofence Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Geofence Type</td>
                    <td>{{ item.type }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>

            <l-polygon
              v-for="(item, index) in geofence.polygon_out"
              :key="'OUT' + index"
              :lat-lngs="item.latlngs"
              :color="item.color"
              :fillColor="item.color"
              :visible="show_hide.geofence == true"
            >
              <l-popup>
                <div class="leaflet-popup-header">Geofence Zone</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>Geofence Name</td>
                    <td>{{ item.name }}</td>
                  </tr>
                  <tr>
                    <td>Geofence Type</td>
                    <td>{{ item.type }}</td>
                  </tr>
                </table>
              </l-popup>
            </l-polygon>

            <!-- =============== START POI POLYGONE ================= -->

            <l-layer-group :visible="isPermanentPoi">
              <l-polygon
                v-for="item in poi.polygon"
                :key="item.id"
                :lat-lngs="item.latlngs"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: true,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
                <!-- <l-popup>
                  <div class="leaflet-popup-header">Point of Interest</div>
                  <table class="leaflet-popup-table">
                    <tr>
                      <td>POI Name</td>
                      <td>{{ item.name }}</td>
                    </tr>
                  </table>
                </l-popup> -->
              </l-polygon>
            </l-layer-group>

            <l-layer-group :visible="!isPermanentPoi">
              <l-polygon
                v-for="item in poi.polygon"
                :key="item.id"
                :lat-lngs="item.latlngs"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: false,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
              </l-polygon>
            </l-layer-group>

            <!-- =============== END POI POLYGONE ================= -->

            <!-- =============== START POI MARKER ================= -->

            <l-layer-group :visible="isPermanentPoi">
              <l-marker
                v-for="item in poi.marker"
                :key="item.id"
                :lat-lng="item.latlngs"
                :icon="item.icon"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: true,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
              </l-marker>
            </l-layer-group>

            <l-layer-group :visible="!isPermanentPoi">
              <l-marker
                v-for="item in poi.marker"
                :key="item.id"
                :lat-lng="item.latlngs"
                :icon="item.icon"
                :visible="show_hide.poi == true"
              >
                <l-tooltip
                  :options="{
                    interactive: true,
                    permanent: false,
                    direction: 'top',
                    className: 'leaflet-tooltip'
                  }"
                  >POI : {{ item.name }}</l-tooltip
                >
              </l-marker>
            </l-layer-group>

            <!-- =============== END POI MARKER ================= -->

            <l-rotated-marker
              v-for="(item, index) in markers"
              :key="`${index}_${item.id}`"
              :lat-lng="item.position"
              :icon="item.icon"
              :rotationAngle="item.angle"
              :visible="item.visible"
            >
              <l-tooltip
                :options="{
                  permanent: true,
                  interactive: true,
                  direction: 'right',
                  className: 'leaflet-tooltip'
                }"
                >{{ item.deviceName }}</l-tooltip
              >
              <l-popup :options="{}">
                <div class="leaflet-popup-header">Device Detail</div>
                <table class="leaflet-popup-table">
                  <tr>
                    <td>License Plate</td>
                    <td>{{ item.plate }}</td>
                  </tr>
                  <tr v-if="actor.privilege <= 4">
                    <td>GSM Number</td>
                    <td>{{ item.gsm }}</td>
                  </tr>
                  <!-- <tr>
                    <td>Alarm</td>
                    <td>{{ item.alarm }}</td>
                  </tr> -->
                  <tr>
                    <td>ACC</td>
                    <td>{{ item.acc }}</td>
                  </tr>
                  <tr>
                    <td>Speed</td>
                    <td>{{ item.speed }}</td>
                  </tr>
                  <tr>
                    <td>Temperature</td>
                    <td>
                      {{
                        item.temperature == null || item.temperature == 'NULL'
                          ? `N/A`
                          : `${item.temperature}&deg;C`
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Door</td>
                    <td>
                      {{
                        item.door == null || item.door == 'NULL'
                          ? 'N/A'
                          : item.door == 1
                          ? `Open`
                          : 'Close'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Alarm</td>
                    <td>
                      {{ item.alarm }}
                    </td>
                  </tr>
                  <tr>
                    <td>Battery</td>
                    <td>
                      <img
                        style="width: 30px"
                        :src="`https://img.gps.id/assets/battery/${item.battery}.png`"
                      />
                      <!-- :src="`${publicPath}battery/${item.battery}.png`" -->
                    </td>
                  </tr>
                  <tr>
                    <td>Mileage</td>
                    <td>
                      {{
                        (parseInt(item.mileage) / 1000)
                          .toFixed(2)
                          .toString()
                          .replace('.', ',')
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      }}
                      Km
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td v-if="showAddress">{{ item.address }}</td>
                    <td v-else>
                      <a
                        href="javascript:;"
                        @click="
                          getAddress(
                            {
                              lat: item.latLon.split(', ')[1],
                              lon: item.latLon.split(', ')[0]
                            },
                            'markers',
                            index
                          )
                        "
                        >Show</a
                      >
                    </td>
                    <!-- <td v-else>
                      <a href="javascript:;" @click="showAddress = !showAddress"
                        >Show</a
                      >
                    </td> -->
                  </tr>
                  <!-- <tr>
                    <td>URL</td>
                    <td><a :href="item.url" target="_blank">Open Google Maps</a></td>
                  </tr> -->
                  <tr>
                    <td style="width: 48%">Expired GSM</td>
                    <td
                      :style="
                        new Date(item.expired_gsm) < new Date()
                          ? `color:red`
                          : ``
                      "
                    >
                      {{
                        `${item.expired_gsm} ${
                          new Date() > new Date(item.expired_gsm)
                            ? '(Expired)'
                            : ''
                        }`
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Longitude</td>
                    <td>{{ item.latLon.split(', ')[0] }}</td>
                  </tr>
                  <tr>
                    <td>Latitude</td>
                    <td>{{ item.latLon.split(', ')[1] }}</td>
                  </tr>
                  <tr>
                    <td>Lifetime Warranty</td>
                    <td
                      :style="item.lifetime_warranty === 0 ? `color:red` : ``"
                    >
                      {{
                        item.lifetime_warranty === 1
                          ? 'Active'
                          : item.lifetime_warranty === 0
                          ? 'Not Active'
                          : 'Not Available'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Last Positioning</td>
                    <td>{{ item.time }}</td>
                  </tr>
                  <tr>
                    <td>Last Update</td>
                    <td>{{ item.serverTime }}</td>
                  </tr>
                  <tr v-if="actor.privilege <= 2">
                    <td></td>
                    <td>
                      <a href="javascript:;" @click="reset_time(item, index)"
                        ><span v-if="!loading_reset_time">Reset Time</span
                        ><span v-else>Loading...</span></a
                      >
                    </td>
                  </tr>
                </table>

                <div class="leaflet-popup-footer">
                  <a href="javascript:;" @click="playback(item.imei)"
                    >Track&nbsp;Replay</a
                  >
                  <a
                    href="javascript:;"
                    @click="playbackV2(item.imei)"
                    v-if="
                      actor.username === 'testingpanicbutton' ||
                      actor.username === 'sby_rob' ||
                      actor.username === 'ptk_owner' ||
                      actor.username === 'tonipras' ||
                      actor.username === 'super'
                    "
                    >PlaybackV2
                  </a>
                  <a
                    href="javascript:;"
                    v-if="actor.privilege <= 4"
                    @click="command(item.imei, item.gps_type)"
                    >Command</a
                  >
                  <a href="javascript:;" @click="detail(item.imei)">Detail</a>
                  <a href="javascript:;" @click="alert(item.imei)">Alert</a>
                </div>
                <div class="leaflet-popup-footer" v-if="actor.privilege == 4">
                  <a href="javascript:;" @click="create_poi(item)"
                    >Add&nbsp;POI</a
                  >
                </div>
              </l-popup>
            </l-rotated-marker>
          </l-map>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <vs-popup
        classContent="popup-example"
        title="Device Detail"
        :active.sync="popUpDetail"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Imei"
                class="w-full"
                v-model="input.imei"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Gsm Number"
                class="w-full"
                v-model="input.gsm_no"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Plate Number"
                class="w-full"
                v-model="input.plate"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Device Name"
                class="w-full"
                v-model="input.device_name"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Gps Type"
                class="w-full"
                v-model="input.gps_type"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Vehicle Type"
                class="w-full"
                v-model="input.veh_type"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label mb-2">Icon</label>
              <div class="pl-3">
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.parking"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.acc_on"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.lost"
                />
                <img
                  class="mr-2"
                  style="width: 50px; height: 50px"
                  :src="input.icon.alarm"
                />
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Register Date"
                class="w-full"
                v-model="input.register_date"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Branch"
                class="w-full"
                v-model="input.branch"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Owner"
                class="w-full"
                v-model="input.owner"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Installer (Technician)"
                class="w-full"
                v-model="input.technician"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Year"
                class="w-full"
                v-model="input.year"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Engine Number"
                class="w-full"
                v-model="input.nomesin"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Chasis Number"
                class="w-full"
                v-model="input.norangka"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Expired STNK"
                class="w-full"
                v-model="input.stnk"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Speed Limit"
                class="w-full"
                v-model="input.speed_limit"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Expired GSM"
                class="w-full"
                v-model="input.expired_gsm"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Lifetime Warranty"
                class="w-full"
                :style="input.lifetime_warranty === 0 ? `color:red` : ``"
                :value="
                  input.lifetime_warranty === 1
                    ? 'Active'
                    : input.lifetime_warranty === 0
                    ? 'Not Active'
                    : 'Not Available'
                "
              />
            </div>
          </div>
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Online Command"
        :active.sync="popUpCommand"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Imei"
                class="w-full"
                v-model="commandImei"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label class="vs-input--label">Command Type</label>
              <v-select :options="commandList" v-model="commandType"></v-select>
            </div>
          </div>
          <div class="vx-row mb-3" v-if="commandType">
            <div class="vx-col w-full">
              <vs-tabs>
                <vs-tab
                  @click="cType = 'check'"
                  label="Basic / Check"
                  icon-pack="feather"
                  icon="icon-check"
                >
                  <div class="tab-text pt-3">
                    <vs-button
                      v-show="commandType.check"
                      id="checkCommandBtn"
                      class="mr-3 mb-2 vs-con-loading__container"
                      @click="sendCommand"
                      >Send</vs-button
                    >
                  </div>
                </vs-tab>
                <vs-tab
                  @click="cType = 'set'"
                  label="Set"
                  icon-pack="feather"
                  icon="icon-edit"
                >
                  <div class="tab-text pt-3">
                    <code v-if="!commandType.set">Unsupported command</code>
                    <div v-else>
                      <div
                        class="vx-row mb-3"
                        v-for="(item, index) in JSON.parse(commandType.set)
                          .input"
                        :key="index"
                      >
                        <div class="vx-col w-full">
                          <vs-input
                            :label="item.label"
                            v-model.lazy="commandInput[index]"
                            class="w-full"
                            :description-text="item.description"
                          />
                        </div>
                      </div>
                    </div>

                    <vs-button
                      v-show="commandType.set"
                      id="setCommandBtn"
                      class="mr-3 mb-2 vs-con-loading__container"
                      @click="sendCommand"
                      >Send</vs-button
                    >
                  </div>
                </vs-tab>
                <vs-tab
                  @click="cType = 'unset'"
                  label="Unset"
                  icon-pack="feather"
                  icon="icon-trash-2"
                >
                  <div class="tab-text pt-3">
                    <code v-if="!commandType.unset">Unsupported command</code>

                    <div v-else>
                      <div
                        class="vx-row mb-3"
                        v-for="(item, index) in JSON.parse(commandType.unset)
                          .input"
                        :key="index"
                      >
                        <div class="vx-col w-full">
                          <vs-input
                            :label="item.label"
                            v-model.lazy="commandInput[index]"
                            class="w-full"
                            :description-text="item.description"
                          />
                        </div>
                      </div>
                    </div>

                    <vs-button
                      v-show="commandType.unset"
                      id="unsetCommandBtn"
                      class="mr-3 mb-2 vs-con-loading__container"
                      @click="sendCommand"
                      >Send</vs-button
                    >
                  </div>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
          <div class="vx-row mb-3 pt-6" v-else>
            <div class="vx-col w-full centerx">
              <code>Select Command Type First</code>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <label class="vs-input--label">Result</label>
              <vs-textarea disabled v-model="commandResult" rows="4" />
            </div>
          </div>
          <!-- <div class="vx-row pt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button v-show="commandType" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="sendCommand">Send</vs-button>
            </div>
          </div> -->
        </template>
      </vs-popup>

      <vs-popup
        classContent="popup-example"
        title="Add POI"
        :active.sync="popUpAddPoi"
      >
        <template>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full required">
              <vs-input
                label="POI Name"
                class="w-full"
                v-model="poi_add.name"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full required">
              <label class="vs-input--label mb-2">Icon</label>
              <v-select :options="iconList" v-model="poi_add.icon">
                <template slot="option" slot-scope="option">
                  <img
                    style="width: 50px; height: 50px"
                    :src="`${option.icon}`"
                  />
                </template>
              </v-select>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full required">
              <vs-input label="Latitude" class="w-full" v-model="poi_add.lat" />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 w-full required">
              <vs-input
                label="Longitude"
                class="w-full"
                v-model="poi_add.lon"
              />
            </div>
          </div>
          <div style="height: 50px"></div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit_poi"
                >Submit</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<style>
.leaflet-tooltip {
  position: absolute;
  margin: 5px;
  background-color: #1da1f2 !important;
  border: 1px solid white;
  border-radius: 8px 8px;
  color: white;
  font-size: 12.5px;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.btn_poi {
  z-index: 1000;
  border: 0.16em solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
  width: 48px;
  height: 48px;
  padding: 0px !important;
}

.btn_poi img {
  margin-top: 0px;
  margin-left: 0px;
}

.example-custom-control {
  background: #fff;
  padding: 0.5em 0.1em;
  border: 0.16em solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
}

.example-custom-control2 {
  cursor: pointer;
  padding: 1.5px 1px;
  background: #fff;
  border: 1.8px solid rgb(169, 169, 169);
  border-radius: 0.4em;
  margin-right: 0.1em;
  width: 35px;
  height: 38px;
  padding: 0px !important;
  /* box-shadow: 4px 4px 6px 2px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 12px 8px 6px 1px rgba(0, 0, 0, 0.48); */
}

.example-custom-control2 img {
  margin-left: 1.2px;
  margin-top: 1.5px;
}

.animation-icon {
  transition-duration: 1s;
  transition-timing-function: linear;
}
</style>

<!--<style lang="stylus">
#parentx
  overflow hidden
  height 500px
  position relative

.header-sidebar
  display flex
  align-items center
  justify-content center
  flex-direction column
  width 100%
  h4
    display flex
    align-items center
    justify-content center
    width 100%
    > button
      margin-left 10px
.footer-sidebar
  display flex
  align-items center
  justify-content space-between
  width 100%
  > button
      border 0px solid rgba(0,0,0,0) !important
      border-left 1px solid rgba(0,0,0,.07) !important
      border-radius 0px !important
</style> -->

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LMarker,
  LTooltip,
  LPolygon,
  LPopup,
  LControlLayers,
  LControl,
  LControlZoom,
  LLayerGroup
} from 'vue2-leaflet'
import LControlPolylineMeasure from 'vue2-leaflet-polyline-measure'
import { VTree } from 'vue-tree-halower'
import vSelect from 'vue-select'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'

import 'leaflet/dist/leaflet.css'

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowSize: [0, 0],
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [20, 30]
})

import LControlFullscreen from 'vue2-leaflet-fullscreen'

export default {
  components: {
    vSelect,
    LMap,
    LControl,
    LTileLayer,
    LMarker,
    LPolygon,
    LTooltip,
    LPopup,
    LControlLayers,
    VTree,
    LRotatedMarker,
    LControlPolylineMeasure,
    LControlFullscreen,
    LControlZoom,
    LLayerGroup
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      data: [],
      actor: {},
      token: '',
      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ],
      map: {
        center: L.latLng(-6.21011, 106.832459), //-1.041276, 122.288486
        zoom: 12
      },

      mapOptions: {
        // zoomSnap: 0.5
        zoomControl: false
      },
      treeData: [],
      markers: [],

      poi: {
        marker: [],
        polygon: []
      },

      zone_speed: {
        polygon: []
      },

      geofence: {
        polygon_in: [],
        polygon_out: []
      },

      sideActive: false,
      keyword: '',
      temp_keyword: '',
      type: 'vehicle',

      searchList: [],
      searchListDefault: '',
      selected: [],
      topMustExpand: true,

      popUpDetail: false,
      popUpCommand: false,

      input: {
        imei: '',
        branch: '',
        technician: '',
        owner: '',
        gsm_no: '',
        plate: '',
        gps_type: '',
        veh_type: '',
        icon: '',
        year: '',
        nomesin: '',
        norangka: '',
        register_date: null,
        speed_limit: '',
        device_name: '',
        expired_gsm: '',
        lifetime_warranty: ''
      },

      allCommandList: [],

      commandInput: ['', '', '', '', '', '', ''],
      commandImei: '',
      commandGpsType: '',
      commandList: [],
      commandType: '',
      commandResult: '',
      cType: '',

      ws: '',
      isConnect: 'open',
      allVehicle: [],
      showAddress: false,

      timer: null,

      show_hide: {
        poi: false,
        geofence: false,
        speed_zone: false
      },

      show_hide_color: {
        poi: 'white',
        geofence: 'white',
        speed_zone: 'white'
      },

      re_center: false,
      last_map_position: [],
      last_vehicle: '',
      selected_all: false,
      total_vehicle: 0,
      mainParent: 0,
      list_alarm: [],

      popUpAddPoi: false,
      iconList: [],
      poi_add: {
        name: '',
        lat: '',
        lon: '',
        type: '',
        geom: '',
        icon: ''
      },
      loading: false,
      loading_reset_time: false,
      isPermanentPoi: false,
      clicks: 0
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 992
    },

    image_source() {
      return `${this.$api.base_url}/uploads/icon`
    },

    noOptionText() {
      return this.keyword
        ? `No ${this.type} found.`
        : this.actor.privilege >= 4
        ? 'Type to search'
        : 'No data found'
    }
  },

  watch: {
    keyword() {
      if (this.keyword !== null) {
        this.allVehicle = []
        this.clearAllSelected()
        if (this.type === 'user') {
          // if (this.ws) {
          //   this.ws.send('REMOVE_CLIENT')
          // }

          if (this.keyword === '') return false

          this.topMustExpand = true
          this.treeData = [
            {
              id: this.keyword.value,
              title: `${this.keyword.title.toUpperCase()}`,
              children: [],
              selDisabled: true,
              nocheck: false,
              expanded: false
            }
          ]
        } else {
          // if (typeof this.keyword === 'string') return false
          if (this.keyword === '') return false

          let title = this.keyword.label
          let selected = false

          if (this.selected.indexOf(this.keyword.value) !== -1) {
            selected = true
          }

          this.$http
            .get(`${this.$api.endpoint}/gps/detail/${this.keyword.value}`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              params: {
                isWeb: true
              }
            })
            .then((res) => {
              let data = res.data.message.data

              let type = ''
              if (data.is_expired) type = 'alarm'
              else {
                if (
                  Date.now() - new Date(data.server_time).getTime() >=
                  86400000
                ) {
                  type = 'lost'
                } else {
                  if (data.alert != 0) type = 'alarm'
                  else {
                    if (
                      data.acc === 1 ||
                      (data.speed > 3 &&
                        Date.now() - new Date(data.time).getTime() <= 600000)
                    ) {
                      type = 'acc_on'
                    } else type = 'parking'
                  }
                }
              }

              const color = {
                parking: 'parking',
                acc_on: 'acc_on',
                alarm: 'alarm',
                lost: 'lost'
              }

              title = `<img src="${
                data.fullpath_icon[type]
              }" style="width: 25px; background:none; float: left"> ${
                data.is_expired
                  ? this.keyword.label + ' (EXPIRED)'
                  : this.keyword.label
              }`

              this.topMustExpand = false
              // this.treeData = [{id: this.keyword.value, title: title, nocheck: true, hasExpanded: false, selected: selected, selDisabled: data.is_expired }]
              this.treeData = [
                {
                  id: this.keyword.value,
                  title: title,
                  nocheck: true,
                  hasExpanded: false,
                  selected: selected,
                  is_portable: data._gps_type.is_portable,
                  acc: data._gps_type.is_portable ? 'N/A' : data.acc,
                  speed: data.speed,
                  alert: data.alert,
                  alert_db: data.alert,
                  fullpath_icon: data.fullpath_icon,
                  label: data.is_expired
                    ? this.keyword.label + ' (EXPIRED)'
                    : this.keyword.label
                }
              ]

              if (this.ws) {
                if (!data.is_expired) {
                  this.allVehicle = [`${data.port}:${data.imei}`]
                  // this.ws.send('REMOVE_CLIENT')
                  let message = 'NEW_CLIENT=' + this.allVehicle.join(',')
                  this.ws.send(message)
                }
              }
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }
      } else {
        this.searchList = []
        this.clearAllSelected()
        if (this.actor.privilege >= 4) {
          this.topMustExpand = true
          this.treeData = [
            {
              id: this.actor.id,
              // title: this.actor.username,
              title: this.actor.username_vehicle,
              children: [],
              selDisabled: true,
              nocheck: false
            }
          ]
        }
      }
    },

    cType() {
      // this.commandInput = {}
      if (this.cType === 'set' || this.cType === 'unset') {
        if (JSON.parse(this.commandType[this.cType]) != null) {
          var input = JSON.parse(this.commandType[this.cType]).input

          input.map((item, index) => {
            this.commandInput[index] = ''
          })
        }
      }
    },

    commandType() {
      if (this.commandType) {
        if (this.commandType.check) this.cType = 'check'
        else if (this.commandType.set) this.cType = 'set'
        else if (this.commandType.unset) this.cType = 'unset'
        else this.cType = ''
      }
    },

    treeData: {
      handler() {
        setTimeout(() => {
          this.removeNodeTitle()
        }, 500)
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        if (this.actor.privilege >= 4) {
          this.getPoiList()
          this.getZoneSpeedList()
          this.getGeofenceZone()
        }
        if (this.actor.privilege >= 4)
          this.treeData = [
            {
              id: this.actor.id,
              // title: this.actor.username.toUpperCase(),
              title: this.actor.username_vehicle,
              children: [],
              selDisabled: true,
              nocheck: false,
              expanded: false
            }
          ]
        if (this.actor.privilege === 6) this.type = 'vehicle'
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    this.getPoiIcon()

    window.addEventListener('beforeunload', () => {
      if (this.ws) {
        this.ws.send('REMOVE_CLIENT')
        this.ws.close()
      }
    })
  },

  mounted() {
    this.connect()
    this.sideActive = this.isSmallerScreen ? false : true
    this.get_alarm()
  },

  beforeDestroy() {
    if (this.ws) {
      this.ws.send('REMOVE_CLIENT')
      this.ws.close()
    }
  },

  methods: {
    reCenter() {
      this.re_center = true
      if (this.re_center) {
        var index = this.last_map_position.length
        if (index > 0) {
          if (this.last_map_position[index - 1].lat == 0) {
            this.map.center = L.latLng(-6.21011, 106.832459)
          } else {
            this.map.center = L.latLng(
              this.last_map_position[index - 1].lat,
              this.last_map_position[index - 1].lon
            )
          }
        }
      }
      this.re_center = false
    },

    removeNodeTitle() {
      const el = this.$el.querySelectorAll('.node-title, .node-title-disabled')
      Object.keys(el).map((index) => {
        el[index].attributes.title.value = ''
      })
    },

    nodechecked(node, is_active) {
      if (node.expanded) {
        if (is_active == true) this.selected = []

        for (let i = 0; i < node.children.length; i++) {
          if (node.children[i].type == 'user') {
            if (node.children[i].expanded) {
              for (let x = 0; x < node.children[i].children.length; x++) {
                if (node.children[i].children[x].type == 'user') {
                  if (node.children[i].children[x].expanded) {
                    for (
                      let y = 0;
                      y < node.children[i].children[x].children.length;
                      y++
                    ) {
                      if (
                        node.children[i].children[x].children[y].type == 'user'
                      ) {
                        if (node.children[i].children[x].children[y].expanded) {
                          for (
                            let z = 0;
                            z <
                            node.children[i].children[x].children[y].children
                              .length;
                            z++
                          ) {
                            if (
                              node.children[i].children[x].children[y].children[
                                z
                              ].type == 'user'
                            ) {
                              if (
                                node.children[i].children[x].children[y]
                                  .children[z].expanded
                              ) {
                                for (
                                  let aa = 0;
                                  aa <
                                  node.children[i].children[x].children[y]
                                    .children[z].children.length;
                                  aa++
                                ) {
                                  this.show_all_unit(
                                    node.children[i].children[x].children[y]
                                      .children[z],
                                    is_active
                                  )
                                  if (is_active)
                                    node.children[i].children[x].children[
                                      y
                                    ].children[z]['selected'] = 'node-selected'
                                  else
                                    node.children[i].children[x].children[
                                      y
                                    ].children[z]['selected'] = ''
                                }
                              }
                            } else {
                              this.show_all_unit(
                                node.children[i].children[x].children[y]
                                  .children[z],
                                is_active
                              )
                              if (is_active)
                                node.children[i].children[x].children[
                                  y
                                ].children[z]['selected'] = 'node-selected'
                              else
                                node.children[i].children[x].children[
                                  y
                                ].children[z]['selected'] = ''
                            }
                          }
                        }
                      } else {
                        this.show_all_unit(
                          node.children[i].children[x].children[y],
                          is_active
                        )
                        if (is_active)
                          node.children[i].children[x].children[y]['selected'] =
                            'node-selected'
                        else
                          node.children[i].children[x].children[y]['selected'] =
                            ''
                      }
                    }
                  }
                } else {
                  this.show_all_unit(node.children[i].children[x], is_active)
                  if (is_active)
                    node.children[i].children[x]['selected'] = 'node-selected'
                  else node.children[i].children[x]['selected'] = ''
                }
              }
            }
          } else {
            this.show_all_unit(node.children[i], is_active)
            if (is_active) node.children[i]['selected'] = 'node-selected'
            else node.children[i]['selected'] = ''
          }
        }

        this.map.zoom = 6
      }
    },

    show_all_unit(node, selected) {
      this.showAddress = false
      if (selected) {
        this.showAddress = false
        this.selected.push(node.id.toString())
        this.selected_all = true

        let i = -1
        this.markers.map((item, index) => {
          if (item.imei.toString() === node.id) {
            this.markers[index].visible = true
            this.map.center = L.latLng(
              parseFloat(this.markers[index].latLon.split(', ')[1]),
              parseFloat(this.markers[index].latLon.split(', ')[0])
            )
            i = index

            this.last_map_position.push({
              imei: this.markers[index].imei,
              lat: parseFloat(this.markers[index].latLon.split(', ')[1]),
              lon: parseFloat(this.markers[index].latLon.split(', ')[0])
            })

            this.last_vehicle =
              this.last_map_position[this.last_map_position.length - 1].imei

            var index = this.last_map_position.length
            if (index > 0) {
              if (this.last_map_position[index - 1].lat == 0) {
                this.map.center = L.latLng(-6.21011, 106.832459)
              } else {
                this.map.center = L.latLng(
                  this.last_map_position[index - 1].lat,
                  this.last_map_position[index - 1].lon
                )
              }
            }
          }
        })

        if (i === -1) {
          let data = node
          let i = -1
          this.markers.map((item, index) => {
            if (item.imei === data.id) i = index
          })

          if (i === -1) {
            const x = {
              visible: true,
              imei: data.id,
              plate: data.plate,
              deviceName: data.device_name,
              position: L.latLng(
                parseFloat(data.latitude),
                parseFloat(data.longitude)
              ),
              angle: data.angle,

              acc: data.acc === 1 ? 'ON' : 'OFF',
              gsm: data.gsm_no,
              latLon: `${parseFloat(data.longitude)}, ${parseFloat(
                data.latitude
              )}`,
              alarm: data.ref_alert ? data.ref_alert.description : 'None',
              speed: `${data.speed} Km/H`,
              mileage: data.mileage,
              time: data.time,
              door: data.door,
              temperature: data.temperature,
              serverTime: data.server_time,
              address:
                data.longitude == 0 && data.latitude == 0
                  ? 'Belum ada Data'
                  : data.address,
              battery: data.battery,
              gps_type: data.gps_type,
              ref_icon: data.fullpath_icon,
              expired_gsm: data.expired_gsm,
              lifetime_warranty: data.lifetime_warranty
            }

            let type = ''

            if (data.is_expired) type = 'alarm'
            else {
              if (
                Date.now() - new Date(data.server_time).getTime() >=
                86400000
              ) {
                type = 'lost'
              } else {
                if (data.alert != 0) type = 'alarm'
                else {
                  if (
                    data.acc === 1 ||
                    (data.speed > 3 &&
                      Date.now() - new Date(data.time).getTime() <= 600000)
                  ) {
                    type = 'acc_on'
                  } else type = 'parking'
                }
              }
            }

            x.type = type

            if (data.icon)
              x.icon = L.icon({
                iconUrl: `${data.fullpath_icon[type]}`,
                iconSize: [32, 32]
              })
            else x.icon = L.icon.Default

            this.markers.push(x)
            // this.getAddress(
            //   { lat: data.latitude, lon: data.longitude },
            //   'markers',
            //   this.markers.length - 1
            // )

            this.last_map_position.push({
              imei: data.id,
              lat: parseFloat(data.latitude),
              lon: parseFloat(data.longitude)
            })

            this.last_vehicle =
              this.last_map_position[this.last_map_position.length - 1].imei
          }

          this.reCenter()
        }
      } else {
        this.selected.splice(this.selected.indexOf(node.id), 1)
        this.markers.map((item, index) => {
          if (item.imei.toString() === node.id) {
            this.markers[index].visible = false

            //delete longlat from list
            this.last_map_position = this.last_map_position.filter(
              (list_data) => list_data.imei !== this.markers[index].imei
            )

            if (this.last_map_position.length > 0) {
              this.last_vehicle =
                this.last_map_position[this.last_map_position.length - 1].imei

              this.reCenter()
            } else {
              this.map.center = L.latLng(-6.21011, 106.832459)
            }
          }
        })
      }
    },

    clearAllSelected() {
      this.markers.map((item, index) => {
        this.selected.splice(this.selected.indexOf(item.imei), 1)
        this.markers[index].visible = false

        //delete longlat from list
        this.last_map_position = this.last_map_position.filter(
          (list_data) => list_data.imei !== this.markers[index].imei
        )

        this.map.center = L.latLng(-6.21011, 106.832459)
      })

      this.selected_all = false
      this.total_vehicle = 0
    },

    nodeSelect(node, selected) {
      if (selected) {
        if (this.isConnect != 'open') {
          this.connect()
        }

        this.showAddress = false
        this.selected.push(node.id.toString())
        // if(this.ws) {
        //   let message = "NEW_CLIENT=" + this.selected.join(',')
        //   this.ws.send(message)
        // }
        let i = -1
        this.markers.map((item, index) => {
          if (item.imei.toString() === node.id) {
            this.markers[index].visible = true
            this.map.center = L.latLng(
              parseFloat(this.markers[index].latLon.split(', ')[1]),
              parseFloat(this.markers[index].latLon.split(', ')[0])
            )
            i = index

            this.last_map_position.push({
              imei: this.markers[index].imei,
              lat: parseFloat(this.markers[index].latLon.split(', ')[1]),
              lon: parseFloat(this.markers[index].latLon.split(', ')[0])
            })

            this.last_vehicle =
              this.last_map_position[this.last_map_position.length - 1].imei
          }
        })

        if (i === -1) {
          this.$http
            .get(`${this.$api.endpoint}/gps/detail/${node.id}`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              params: {
                isWeb: true
              }
            })
            .then((res) => {
              let data = res.data.message.data
              let i = -1
              this.markers.map((item, index) => {
                if (item.imei === data.imei) i = index
              })

              if (i === -1) {
                let battery

                if (parseInt(data.battery) > 80) battery = '6'
                else if (parseInt(data.battery) > 60) battery = '5'
                else if (parseInt(data.battery) > 40) battery = '4'
                else if (parseInt(data.battery) > 20) battery = '3'
                else if (parseInt(data.battery) > 5) battery = '2'
                else if (parseInt(data.battery) >= 0) battery = '1'
                else battery = '-1'

                data.acc = node.acc
                data.speed = node.speed
                data.alert = node.alert

                const x = {
                  visible: true,
                  imei: data.imei,
                  plate: data.plate,
                  deviceName: data.device_name,
                  position: L.latLng(data.lat, data.lon),
                  angle: data.angle,
                  is_portable: data._gps_type.is_portable,
                  acc: data._gps_type.is_portable
                    ? 'N/A'
                    : data.acc === 1
                    ? 'ON'
                    : 'OFF',
                  gsm: data.gsm_no,
                  latLon: `${data.lon}, ${data.lat}`,
                  alarm:
                    data.alert == 0
                      ? '-'
                      : data.alert == data.ref_alert.alert_no
                      ? data.ref_alert.description
                      : this.list_alarm.find(
                          (e) => e.value === parseInt(data.alert)
                        ).label,

                  speed: `${data.speed} Km/H`,
                  mileage: data.mileage,
                  time: data.time,
                  door: data.door,
                  temperature: data.temperature,
                  serverTime: data.server_time,
                  address:
                    data.lon == 0 && data.lat == 0
                      ? 'Belum ada Data'
                      : data.address,
                  battery: battery,
                  gps_type: data.gps_type,
                  // ref_icon: data.icon,
                  ref_icon: data.fullpath_icon,
                  expired_gsm: data.expired_gsm,
                  lifetime_warranty: data.lifetime_warranty
                  // url: `https://google.com/maps/search/?api=1&query=${data.lat},${data.lon}`
                }

                let type = ''

                if (data.is_expired) type = 'alarm'
                else {
                  if (
                    Date.now() - new Date(data.server_time).getTime() >=
                    86400000
                  ) {
                    type = 'lost'
                  } else {
                    if (data.alert != 0) type = 'alarm'
                    else {
                      if (
                        data.acc === 1 ||
                        (data.speed > 3 &&
                          Date.now() - new Date(data.time).getTime() <= 600000)
                      ) {
                        type = 'acc_on'
                      } else type = 'parking'
                    }
                  }
                }

                // console.log()

                x.type = type

                if (data.icon)
                  x.icon = L.icon({
                    iconUrl: `${data.fullpath_icon[type]}`,
                    iconSize: [32, 32]
                  })
                else x.icon = L.icon.Default

                this.markers.push(x)
                // this.getAddress(
                //   { lat: data.lat, lon: data.lon },
                //   'markers',
                //   this.markers.length - 1
                // )
              }

              this.map.center = L.latLng(data.lat, data.lon)

              this.last_map_position.push({
                imei: data.imei,
                lat: parseFloat(data.lat),
                lon: parseFloat(data.lon)
              })

              this.last_vehicle =
                this.last_map_position[this.last_map_position.length - 1].imei

              // this.map.zoom = 10
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }
      } else {
        this.selected.splice(this.selected.indexOf(node.id), 1)

        // if(this.ws && this.selected.length > 0) {
        //   let message = "NEW_CLIENT=" + this.selected.join(',')
        //   this.ws.send(message)
        // } else {
        //   this.ws.send("REMOVE_CLIENT")
        // }

        this.markers.map((item, index) => {
          if (item.imei.toString() === node.id) {
            this.markers[index].visible = false
            // if(item.imei.toString() === node.id) this.markers.splice(index, 1)

            //delete longlat from list
            this.last_map_position = this.last_map_position.filter(
              (list_data) => list_data.imei !== this.markers[index].imei
            )

            if (this.last_map_position.length > 0) {
              this.last_vehicle =
                this.last_map_position[this.last_map_position.length - 1].imei

              this.reCenter()
            }
          }
        })
      }
    },

    nodeExpand(node, expand, position) {
      if (expand) {
        let x = this.treeData[0].children
        let levelForChildren = 1
        let parentForChildren = 0

        for (let counter = 1; counter < position.level; counter++) {
          //===== cara unutk menampilkan shared under level Dispather =====
          levelForChildren = position.level
          parentForChildren = position.index
          //===============================================================

          //===== cara unutk menampilkan shared under level limited =====
          if (node.levelParent == 2) {
            this.mainParent = node.indexParent
          }
          //===============================================================

          if (node.levelParent == 1) {
            x = x[position.index].children
          } else if (node.levelParent == 2) {
            if (counter == 2) {
              x = x[position.index].children
            } else {
              x = x[node.indexParent].children
            }
          } else if (node.levelParent == 3) {
            if (counter == 3) {
              x = x[position.index].children
            } else if (counter == 2) {
              x = x[node.indexParent].children
            } else if (counter == 1) {
              x = x[this.mainParent].children
            }
          }
        }

        x.splice(0, x.length)

        x.push({
          title: 'Loading...',
          hasExpanded: true,
          selDisabled: true,
          nocheck: true
        })

        this.$http
          .get(
            `${this.$api.endpoint}/tracking/child2/${node.id}?owner=${node.title}&levelParent=${levelForChildren}&indexParent=${parentForChildren}&mainParent=${this.mainParent}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            x.splice(0, 1)
            if (res.data.message.data.length == 0)
              x.push({
                title: 'No Data',
                hasExpanded: true,
                selDisabled: true,
                nocheck: true,
                children: []
              })

            res.data.message.data.map((item) => {
              let color = 'parking'

              if (item.is_expired) color = 'alarm'
              else {
                if (
                  Date.now() - new Date(item.server_time).getTime() >=
                  86400000
                ) {
                  color = 'lost' // lost
                } else {
                  if (item.alert != 0) color = 'alarm'
                  //alarm
                  else {
                    if (
                      item.acc === 1 ||
                      (item.speed > 3 &&
                        Date.now() - new Date(item.time).getTime() <= 600000)
                    ) {
                      color = 'acc_on' // acc_on
                    } else color = 'parking' // parking
                  }
                }
              }

              if (item.type === 'vehicle') {
                this.total_vehicle = this.total_vehicle + 1
                // item.title = `<img src="${this.$api.base_url}/uploads/icon/${
                //   item.icon[color]
                // }" style="width: 25px; background:none; float: left"> ${
                //   item.is_expired ? item.title + ' (EXPIRED)' : item.title
                // }`

                item.title = `<img src="${
                  item.fullpath_icon[color]
                }" style="width: 25px; background:none; float: left"> ${
                  item.is_expired ? item.title + ' (EXPIRED)' : item.title
                }`

                if (!item.is_expired)
                  this.allVehicle.push(`${item.port}:${item.id}`)
              }

              let battery

              if (parseInt(item.battery) > 80) battery = '6'
              else if (parseInt(item.battery) > 60) battery = '5'
              else if (parseInt(item.battery) > 40) battery = '4'
              else if (parseInt(item.battery) > 20) battery = '3'
              else if (parseInt(item.battery) > 5) battery = '2'
              else if (parseInt(item.battery) >= 0) battery = '1'
              else battery = '-1'

              item.battery = battery
              item.alert_db = item.alert
              item.selected = false
              // if(item.is_expired) item.selDisabled = true
              if (this.selected.indexOf(item.id) !== -1) {
                item.selected = true
              }
              x.push(item)
            })

            if (this.isConnect != 'open') {
              this.isConnect = 'close'
              this.connect()
            } else {
              if (this.allVehicle.length > 0) {
                let message = 'NEW_CLIENT=' + this.allVehicle.join(',')
                this.ws.send(message)
              }
            }
          })
      } else {
        node.children.map((data, val) => {
          if (data.type == 'user') {
            data.children.map((data2, val2) => {
              if (data2.type == 'user') {
                data2.children.map((data3, val3) => {
                  this.total_vehicle = this.total_vehicle - 1
                  this.selected.splice(this.selected.indexOf(data3.id), 1)

                  this.markers = this.markers.filter(
                    (item3) => item3.imei !== data3.id
                  )

                  this.last_map_position = this.last_map_position.filter(
                    (list_data) => list_data.imei !== data3.id
                  )
                })
              } else {
                this.total_vehicle = this.total_vehicle - 1
                this.selected.splice(this.selected.indexOf(data2.id), 1)

                this.markers = this.markers.filter(
                  (item2) => item2.imei !== data2.id
                )

                this.last_map_position = this.last_map_position.filter(
                  (list_data) => list_data.imei !== data2.id
                )
              }
            })
          } else {
            this.total_vehicle = this.total_vehicle - 1
            this.selected.splice(this.selected.indexOf(data.id), 1)

            this.markers = this.markers.filter((item) => item.imei !== data.id)

            this.last_map_position = this.last_map_position.filter(
              (list_data) => list_data.imei !== data.id
            )
          }
        })
      }
    },

    search(search) {
      if (search.length >= 3) {
        // if (this.searchList.length == 0) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: '#btnSearch',
          scale: 0.45
        })

        this.loading = true

        this.timer = setTimeout(() => {
          this.$http
            .get(
              `${this.$api.endpoint}/tracking/search?keyword=${search}&type=${this.type}&isTracking=true`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`
                }
              }
            )
            .then((res) => {
              this.$vs.loading.close(`#btnSearch > .con-vs-loading`)
              this.searchList = res.data.message.data
              this.searchListDefault = this.searchList.find((e, i) => {
                return i === 0
              })

              this.temp_keyword = ''
              this.loading = false
            })
            .catch((error) => {
              if (this.actor.privilege <= 3)
                this.$vs.loading.close(`#btnSearch > .con-vs-loading`)

              this.$gf.httpErrorHandler(error)
              this.loading = false
            })
        }, 1000)
        // }
      } else {
        if (this.actor.privilege <= 3)
          this.$vs.loading.close(`#btnSearch > .con-vs-loading`)

        this.loading = false
      }
    },

    playback(imei) {
      let route = this.$router.resolve({ path: `/track-replay/${imei}` })
      window.open(route.href, '_blank')
    },

    playbackV2(imei) {
      let route = this.$router.resolve({ path: `/playback/${imei}` })
      window.open(route.href, '_blank')
    },

    alert(imei) {
      let today = new Date()
      let date = `${today.getFullYear()}-${(today.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

      let start = `${date} 00:00`
      let end = `${date} 23:59`

      // this.$store.dispatch('alarm/setAlarm', {
      //   device: imei,
      //   start_time: start,
      //   end_time: end
      // })

      localStorage.setItem(
        'alertParams',
        JSON.stringify({ device: imei, start_time: start, end_time: end })
      )
      let route = this.$router.resolve({ path: '/alert' })
      window.open(route.href, '_blank')
    },

    detail(imei) {
      this.$http
        .get(`${this.$api.endpoint}/gps/detail/${imei}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data

          this.input.imei = data.imei
          this.input.gsm_no = data.gsm_no
          this.input.plate = data.plate
          this.input.device_name = data.device_name

          this.input.branch = data.branch_name
          // this.input.branch = data._branch_id ? data._branch_id.name : ''
          this.input.technician = data._technician ? data._technician.name : ''
          this.input.owner = data._owner ? data._owner.username : ''
          this.input.gps_type = data._gps_type ? data._gps_type.name : ''
          this.input.veh_type = data._veh_type ? data._veh_type.name : ''

          this.input.year = data.year
          this.input.nomesin = data.nomesin
          this.input.norangka = data.norangka
          this.input.stnk = data.stnk
          this.input.register_date = data.register_date
          this.input.speed_limit = data.speed_limit
          this.input.expired_gsm = data.expired_gsm
          this.input.lifetime_warranty = data.lifetime_warranty

          // this.input.icon = data.icon
          //   ? {
          //       value: data.icon.id,
          //       parking: `${this.image_source}/${data.icon.parking}`,
          //       label: data.icon.name,
          //       acc_on: `${this.image_source}/${data.icon.acc_on}`,
          //       lost: `${this.image_source}/${data.icon.lost}`,
          //       alarm: `${this.image_source}/${data.icon.alarm}`
          //     }
          //   : ''

          this.input.icon = data.fullpath_icon
            ? {
                value: data.fullpath_icon.id,
                parking: `${data.fullpath_icon.parking}`,
                label: data.fullpath_icon.name,
                acc_on: `${data.fullpath_icon.acc_on}`,
                lost: `${data.fullpath_icon.lost}`,
                alarm: `${data.fullpath_icon.alarm}`
              }
            : ''

          this.popUpDetail = true
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    command(imei, gps_type) {
      this.commandResult = ''
      this.commandType = ''
      this.commandImei = imei
      this.commandGpsType = gps_type

      this.$http
        .get(`${this.$api.endpoint}/command/select/${gps_type}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.commandList = res.data.message.data

          this.popUpCommand = true
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })

      // this.commandList = this.allCommandList.filter(item => {
      //   return JSON.parse(item.gps_type.replace('{', '[').replace('}', ']')).indexOf(gps_type) !== -1
      // })
    },

    sendCommand() {
      let clear = true
      let command = this.commandType[this.cType]
      if (this.cType === 'set' || this.cType === 'unset') {
        command = JSON.parse(this.commandType[this.cType]).command
        var input = JSON.parse(this.commandType[this.cType]).input

        const selectedTypeCommand = command.split(',')

        input.map((item, index) => {
          if (selectedTypeCommand[0] == 'SOS') {
            if (this.commandInput[index].length === 0 && index == 0) {
              clear = false
              this.$vs.notify({
                title: 'Sorry',
                text: `${item.label} is required`,
                color: 'danger',
                position: 'top-right'
              })
            }
          } else {
            if (this.commandInput[index].length === 0) {
              clear = false
              this.$vs.notify({
                title: 'Sorry',
                text: `${item.label} is required`,
                color: 'danger',
                position: 'top-right'
              })
            }
          }

          let regex = new RegExp(`\\[${item.slug}]`, 'g')
          command = command
            .toString()
            .replace(regex, this.commandInput[index].toString())
        })
      }

      if (clear === true) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: `#${this.cType}CommandBtn`,
          scale: 0.45
        })

        this.$http
          .post(
            `${this.$api.endpoint}/command/send/${this.commandImei}`,
            {
              command: command,
              gps_type: this.commandGpsType
            },
            {
              headers: {
                Authorization: `Bearer ${this.token}`
              }
            }
          )
          .then((res) => {
            this.$vs.loading.close(`#${this.cType}CommandBtn > .con-vs-loading`)
            this.commandResult = res.data.message
          })
          .catch((err) => {
            this.$vs.loading.close(`#${this.cType}CommandBtn > .con-vs-loading`)
          })

        // var data = new URLSearchParams()
        // data.append('imei', this.commandImei)
        // data.append('command', command)
        // this.$http.post(this.$api.command, data, {
        //   headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        //   }
        // }).then(res => {
        //   this.$vs.loading.close(`#${this.cType}CommandBtn > .con-vs-loading`)
        //   this.commandResult = res.data.message

        //   this.$http.post(`${this.$api.endpoint}/command/log`, {
        //     imei: this.commandImei,
        //     type: this.commandType.label,
        //     command_text: command,
        //     result: res.data.message
        //   }, {
        //     headers: {
        //       Authorization: `Bearer ${this.token}`
        //     }
        //   })
        // }).catch(err => {
        //   this.$vs.loading.close(`#${this.cType}CommandBtn > .con-vs-loading`)
        // })
      }
    },

    secondToDateTime(second) {
      let d = new Date(parseInt(second) * 1000)

      return d.toISOString().replace('T', ' ').replace('.000Z', '')
    },

    geomToPolygon(geom) {
      let start = '(('
      let end = '))'

      geom = geom.substring(
        geom.indexOf(start) + start.length,
        geom.indexOf(end)
      )

      let latlon = geom.split(',')

      let result = []
      latlon.map((item) => {
        let x = item.split(' ')
        result.push([parseFloat(x[1]), parseFloat(x[0])])
      })

      return result
    },

    getPoiList() {
      this.poi.marker = []
      this.poi.polygon = []

      this.$http
        .get(`${this.$api.endpoint}/poi/general`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = item.type === 0 ? 'marker' : 'polygon'
            let latlngs =
              item.type === 0
                ? L.latLng(item.lat, item.lon)
                : this.geomToPolygon(item.geom)

            this.poi[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              icon: item.icon
                ? L.icon({
                    iconUrl: `${
                      item.icon.fullpath_icon
                        ? item.icon.fullpath_icon
                        : item.icon.icon
                    }`,
                    iconSize: [40, 40]
                  })
                : L.icon.Default
            })
          })
        })
        .catch((error) => {})
    },

    getZoneSpeedList() {
      this.$http
        .get(`${this.$api.endpoint}/speed_limit_by_zone/all_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data
          //console.log(data)

          data.map((item, index) => {
            let target = 'polygon'
            let latlngs = this.geomToPolygon(item.geom)

            this.zone_speed[target].push({
              id: item.id,
              name: item.name,
              speed: item.speed,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: '#B8860B'
            })
          })
        })
        .catch((error) => {})
    },

    getGeofenceZone() {
      this.$http
        .get(`${this.$api.endpoint}/zone/geofence_zone`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          var data = res.data.message.data

          data.map((item, index) => {
            let target = item.type == 0 ? 'polygon_in' : 'polygon_out'
            let latlngs = this.geomToPolygon(item.geom)

            this.geofence[target].push({
              id: item.id,
              name: item.name,
              latlngs: latlngs,
              center: L.latLng(item.lat, item.lon),
              color: item.type == 0 ? 'red' : 'green',
              type: item.type == 0 ? 'IN' : 'OUT'
            })
          })
        })
        .catch((error) => {})
    },

    getTitle(str) {
      let res = str.substr(str.indexOf('>') + 1, str.length - str.indexOf('>'))
      return res
    },

    connect() {
      this.ws = new WebSocket(`${this.$api.new_socket}`)

      if (this.ws) {
        this.ws.onopen = (e) => {
          if (this.allVehicle.length > 0) {
            // this.ws.send('NEW_CLIENT=' + this.selected.join(','))
            this.ws.send('NEW_CLIENT=' + this.allVehicle.join(','))

            this.isConnect = 'close'
            if (this.ws.send) {
              this.isConnect = 'open'
              console.log('Socket is open...')
            }
          }
        }
      }

      // this.ws.onclose = () => {
      //   setTimeout(function() {
      //     self.connect();
      //   }, 1000);
      // }

      this.ws.onmessage = (msg) => {
        const data = JSON.parse(msg.data)

        let i = -1
        this.markers.map((item, index) => {
          if (item.imei === data.imei) i = index
        })

        let type = 'parking'

        let time = this.secondToDateTime(parseInt(data.time))

        if (Date.now() - new Date(time).getTime() >= 86400000) {
          type = 'lost'
        } else {
          if (parseInt(data.alarm) != 0) type = 'alarm'
          else {
            if (
              parseInt(data.acc) === 1 ||
              (parseInt(data.speed) > 3 &&
                Date.now() - new Date(time).getTime() <= 600000)
            ) {
              type = 'acc_on'
            } else type = 'parking'
          }
        }

        this.treeData.map((list, li) => {
          if (typeof list.children != 'undefined') {
            if (list.children.length > 0) {
              list.children.map((child, ci) => {
                if (child.type === 'vehicle') {
                  let ctitle = this.getTitle(child.title)
                  if (data.imei === child.id) {
                    if (data.type == 'location') {
                      this.treeData[li].children[ci].alert_db = data.alarm
                    }

                    if (
                      this.treeData[li].children[ci].alert_db != 0 &&
                      data.type == 'heartbeat'
                    ) {
                      type = 'alarm'
                      data.alarm = this.treeData[li].children[ci].alert_db
                    }

                    this.treeData[li].children[
                      ci
                    ].title = `<img src="${this.treeData[li].children[ci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${ctitle}`

                    this.treeData[li].children[ci].alert = parseInt(data.alarm)

                    this.treeData[li].children[ci].acc = parseInt(data.acc)

                    this.treeData[li].children[ci].speed = parseInt(data.speed)
                  }
                } else {
                  if (child.children && child.children.length > 0) {
                    child.children.map((grandchild, gi) => {
                      if (grandchild.type === 'vehicle') {
                        let gtitle = this.getTitle(grandchild.title)
                        if (data.imei === grandchild.id) {
                          if (data.type == 'location') {
                            this.treeData[li].children[ci].children[
                              gi
                            ].alert_db = data.alarm
                          }

                          if (
                            this.treeData[li].children[ci].children[gi]
                              .alert_db != 0 &&
                            data.type == 'heartbeat'
                          ) {
                            type = 'alarm'
                            data.alarm =
                              this.treeData[li].children[ci].children[
                                gi
                              ].alert_db
                          }

                          this.treeData[li].children[ci].children[
                            gi
                          ].title = `<img src="${this.treeData[li].children[ci].children[gi].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gtitle}`

                          this.treeData[li].children[ci].children[gi].alert =
                            parseInt(data.alarm)

                          this.treeData[li].children[ci].children[gi].acc =
                            parseInt(data.acc)

                          this.treeData[li].children[ci].children[gi].speed =
                            parseInt(data.speed)
                        }
                      } else {
                        if (
                          grandchild.children &&
                          grandchild.children.length > 0
                        ) {
                          grandchild.children.map(
                            (great_grandchildren, gci) => {
                              if (great_grandchildren.type === 'vehicle') {
                                let gctitle = this.getTitle(
                                  great_grandchildren.title
                                )
                                if (data.imei === great_grandchildren.id) {
                                  if (data.type == 'location') {
                                    this.treeData[li].children[ci].children[
                                      gi
                                    ].children[gci].alert_db = data.alarm
                                  }

                                  if (
                                    this.treeData[li].children[ci].children[gi]
                                      .children[gci].alert_db != 0 &&
                                    data.type == 'heartbeat'
                                  ) {
                                    type = 'alarm'
                                    data.alarm =
                                      this.treeData[li].children[ci].children[
                                        gi
                                      ].children[gci].alert_db
                                  }

                                  this.treeData[li].children[ci].children[
                                    gi
                                  ].children[
                                    gci
                                  ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gctitle}`

                                  this.treeData[li].children[ci].children[
                                    gi
                                  ].children[gci].alert = parseInt(data.alarm)

                                  this.treeData[li].children[ci].children[
                                    gi
                                  ].children[gci].acc = parseInt(data.acc)

                                  this.treeData[li].children[ci].children[
                                    gi
                                  ].children[gci].speed = parseInt(data.speed)
                                }
                              } else {
                                if (
                                  great_grandchildren.children &&
                                  great_grandchildren.children.length > 0
                                ) {
                                  great_grandchildren.children.map(
                                    (gcvehicle, gcv) => {
                                      let gcvtitle = this.getTitle(
                                        gcvehicle.title
                                      )
                                      if (data.imei === gcvehicle.id) {
                                        if (data.type == 'location') {
                                          this.treeData[li].children[
                                            ci
                                          ].children[gi].children[gci].children[
                                            gcv
                                          ].alert_db = data.alarm
                                        }

                                        if (
                                          this.treeData[li].children[ci]
                                            .children[gi].children[gci]
                                            .children[gcv].alert_db != 0 &&
                                          data.type == 'heartbeat'
                                        ) {
                                          type = 'alarm'
                                          data.alarm =
                                            this.treeData[li].children[
                                              ci
                                            ].children[gi].children[
                                              gci
                                            ].children[gcv].alert_db
                                        }

                                        this.treeData[li].children[ci].children[
                                          gi
                                        ].children[gci].children[
                                          gcv
                                        ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].children[gcv].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gcvtitle}`

                                        this.treeData[li].children[ci].children[
                                          gi
                                        ].children[gci].children[gcv].alert =
                                          parseInt(data.alarm)

                                        this.treeData[li].children[ci].children[
                                          gi
                                        ].children[gci].children[gcv].acc =
                                          parseInt(data.acc)

                                        this.treeData[li].children[ci].children[
                                          gi
                                        ].children[gci].children[gcv].speed =
                                          parseInt(data.speed)
                                      }
                                    }
                                  )
                                }
                              }
                            }
                          )
                        }
                      }
                    })
                  }
                }
              })
            }
          } else {
            if (data.type == 'location') {
              this.treeData[0].alert_db = data.alarm
            }

            if (this.treeData[0].alert_db != 0 && data.type == 'heartbeat') {
              type = 'alarm'
              data.alarm = this.treeData[0].alert_db
            }

            this.treeData[0].title = `<img src="${this.treeData[0].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${this.treeData[0].label}`
            this.treeData[0].alert = parseInt(data.alarm)
            this.treeData[0].acc = parseInt(data.acc)
            this.treeData[0].speed = parseInt(data.speed)
          }
        })

        if (i !== -1) {
          if (data.type === 'location') {
            //====== update center map on vehicle ============

            if (
              this.last_vehicle == this.markers[i].imei &&
              this.markers[i].visible == true
            ) {
              this.last_map_position = this.last_map_position.filter(
                (list_data) => list_data.imei !== this.last_vehicle
              )

              let lat = parseFloat(data.latitude)
              let lon = parseFloat(data.longitude)
              this.last_map_position.push({
                imei: data.imei,
                lat: lat,
                lon: lon
              })

              this.map.center = L.latLng(
                this.last_map_position[this.last_map_position.length - 1].lat,
                this.last_map_position[this.last_map_position.length - 1].lon
              )
            }

            // var index = this.last_map_position.length

            // console.log(index)
            // if (index > 0) {
            //   if (this.last_map_position.length < this.total_vehicle) {
            //     if (this.last_map_position[index - 1].lat == 0) {
            //       this.map.center = L.latLng(-6.21011, 106.832459)
            //     } else {
            //       this.map.center = L.latLng(
            //         this.last_map_position[index - 1].lat,
            //         this.last_map_position[index - 1].lon
            //       )
            //     }
            //   }
            // }

            //====== end update center map on vehicle ============

            // if (data.address == '')

            // if (this.last_map_position.length > 0) {
            //   if (
            //     this.last_map_position[this.last_map_position.length - 1]
            //       .imei == data.imei
            //   ) {
            //     this.getAddress(
            //       { lat: data.latitude, lon: data.longitude },
            //       'markers',
            //       i
            //     )
            //   } else {
            //     this.showAddress = false
            //     this.markers[i].address = data.address
            //   }
            // }

            this.showAddress = false

            // let type = 'parking'

            // if (Date.now() - parseInt(data.time) * 1000 >= 86400000) {
            //   type = 'lost'
            // } else {
            //   if (data.alarm != 0) type = 'alarm'
            //   else {
            //     if (
            //       data.acc == 1 ||
            //       (data.speed > 0 &&
            //         Date.now() - parseInt(data.time) * 1000 <= 600)
            //     ) {
            //       type = 'acc_on'
            //     } else type = 'parking'
            //   }
            // }

            let battery

            if (parseInt(data.voltage) > 80) battery = '6'
            else if (parseInt(data.voltage) > 60) battery = '5'
            else if (parseInt(data.voltage) > 40) battery = '4'
            else if (parseInt(data.voltage) > 20) battery = '3'
            else if (parseInt(data.voltage) > 5) battery = '2'
            else if (parseInt(data.voltage) >= 0) battery = '1'
            else battery = '-1'

            // this.treeData.map((list, li) => {
            //   if (typeof list.children != 'undefined') {
            //     if (list.children.length > 0) {
            //       list.children.map((child, ci) => {
            //         if (child.type === 'vehicle') {
            //           let ctitle = this.getTitle(child.title)
            //           if (data.imei === child.id)
            //             this.treeData[li].children[
            //               ci
            //             ].title = `<img src="${this.treeData[li].children[ci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${ctitle}`
            //         } else {
            //           if (child.children.length > 0) {
            //             child.children.map((grandchild, gi) => {
            //               if (grandchild.type === 'vehicle') {
            //                 let gtitle = this.getTitle(grandchild.title)
            //                 if (data.imei === grandchild.id)
            //                   this.treeData[li].children[ci].children[
            //                     gi
            //                   ].title = `<img src="${this.treeData[li].children[ci].children[gi].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gtitle}`
            //               } else {
            //                 if (grandchild.children.length > 0) {
            //                   grandchild.children.map(
            //                     (great_grandchildren, gci) => {
            //                       if (great_grandchildren.type === 'vehicle') {
            //                         let gctitle = this.getTitle(
            //                           great_grandchildren.title
            //                         )
            //                         if (data.imei === great_grandchildren.id)
            //                           this.treeData[li].children[ci].children[
            //                             gi
            //                           ].children[
            //                             gci
            //                           ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gctitle}`
            //                       } else {
            //                         if (
            //                           great_grandchildren.children.length > 0
            //                         ) {
            //                           great_grandchildren.children.map(
            //                             (gcvehicle, gcv) => {
            //                               let gcvtitle = this.getTitle(
            //                                 gcvehicle.title
            //                               )
            //                               if (data.imei === gcvehicle.id)
            //                                 this.treeData[li].children[
            //                                   ci
            //                                 ].children[gi].children[
            //                                   gci
            //                                 ].children[
            //                                   gcv
            //                                 ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].children[gcv].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gcvtitle}`
            //                             }
            //                           )
            //                         }
            //                       }
            //                     }
            //                   )
            //                 }
            //               }
            //             })
            //           }
            //         }
            //       })
            //     }
            //   }
            // })

            if (this.markers[i].ref_icon) {
              // if(this.markers[i].type !== type) {
              this.markers[i].icon = L.icon({
                // iconUrl: `${this.$api.base_url}/uploads/icon/${this.markers[i].ref_icon[type]}`,
                iconUrl: `${this.markers[i].ref_icon[type]}`,
                iconSize: [32, 32]
                // className:
                //   parseInt(data.angle) - this.markers[i].angle > 50 ||
                //   parseInt(data.angle) - this.markers[i].angle < -50
                //     ? ''
                //     : 'animation-icon'
              })
              // }
            }

            if (!this.markers[i].is_portable) {
              this.markers[i].acc = parseInt(data.acc) === 0 ? 'OFF' : 'ON'
            }

            this.markers[i].position = L.latLng(data.latitude, data.longitude)
            this.markers[i].angle = parseInt(data.angle)
            this.markers[i].latLon = `${data.longitude}, ${data.latitude}`
            this.markers[i].speed = `${data.speed} Km/H`
            this.markers[i].door = data.door
            this.markers[i].temperature =
              data.temperature != 'NULL' ? data.temperature : null
            this.markers[i].mileage = data.mileage
            this.markers[i].battery = battery
            this.markers[i].time = this.secondToDateTime(data.time)
            this.markers[i].serverTime = this.secondToDateTime(data.time)
            this.markers[i].alarm =
              parseInt(data.alarm) == 0
                ? '-'
                : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
                    .label
          } else if (data.type === 'heartbeat') {
            let battery

            if (parseInt(data.voltage) > 80) battery = '6'
            else if (parseInt(data.voltage) > 60) battery = '5'
            else if (parseInt(data.voltage) > 40) battery = '4'
            else if (parseInt(data.voltage) > 20) battery = '3'
            else if (parseInt(data.voltage) > 5) battery = '2'
            else if (parseInt(data.voltage) >= 0) battery = '1'
            else battery = '-1'

            if (!this.markers[i].is_portable) {
              this.markers[i].acc = parseInt(data.acc) === 0 ? 'OFF' : 'ON'
            }

            this.markers[i].serverTime = this.secondToDateTime(data.time)
            this.markers[i].battery = battery
            this.markers[i].door = data.door
            this.markers[i].temperature = data.temperature

            // let type = this.markers[i].type

            // if (type != 'alarm') {
            //   if (
            //     data.acc == 1 ||
            //     (data.speed > 0 &&
            //       Date.now() - parseInt(data.time) * 1000 <= 600)
            //   )
            //     type = 'acc_on'
            //   else type = 'parking'
            // }

            // this.treeData.map((list, li) => {
            //   if (typeof list.children != 'undefined') {
            //     if (list.children.length > 0) {
            //       list.children.map((child, ci) => {
            //         if (child.type === 'vehicle') {
            //           let ctitle = this.getTitle(child.title)
            //           if (data.imei === child.id)
            //             this.treeData[li].children[
            //               ci
            //             ].title = `<img src="${this.treeData[li].children[ci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${ctitle}`
            //         } else {
            //           if (child.children.length > 0) {
            //             child.children.map((grandchild, gi) => {
            //               if (grandchild.type === 'vehicle') {
            //                 let gtitle = this.getTitle(grandchild.title)
            //                 if (data.imei === grandchild.id)
            //                   this.treeData[li].children[ci].children[
            //                     gi
            //                   ].title = `<img src="${this.treeData[li].children[ci].children[gi].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gtitle}`
            //               } else {
            //                 if (grandchild.children.length > 0) {
            //                   grandchild.children.map(
            //                     (great_grandchildren, gci) => {
            //                       if (great_grandchildren.type === 'vehicle') {
            //                         let gctitle = this.getTitle(
            //                           great_grandchildren.title
            //                         )
            //                         if (data.imei === great_grandchildren.id)
            //                           this.treeData[li].children[ci].children[
            //                             gi
            //                           ].children[
            //                             gci
            //                           ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gctitle}`
            //                       } else {
            //                         if (
            //                           great_grandchildren.children.length > 0
            //                         ) {
            //                           great_grandchildren.children.map(
            //                             (gcvehicle, gcv) => {
            //                               let gcvtitle = this.getTitle(
            //                                 gcvehicle.title
            //                               )
            //                               if (data.imei === gcvehicle.id)
            //                                 this.treeData[li].children[
            //                                   ci
            //                                 ].children[gi].children[
            //                                   gci
            //                                 ].children[
            //                                   gcv
            //                                 ].title = `<img src="${this.treeData[li].children[ci].children[gi].children[gci].children[gcv].fullpath_icon[type]}" style="width: 25px; background:none; float: left"> ${gcvtitle}`
            //                             }
            //                           )
            //                         }
            //                       }
            //                     }
            //                   )
            //                 }
            //               }
            //             })
            //           }
            //         }
            //       })
            //     }
            //   }
            // })

            if (this.markers[i].ref_icon) {
              this.markers[i].icon = L.icon({
                // iconUrl: `${this.$api.base_url}/uploads/icon/${this.markers[i].ref_icon[type]}`,
                iconUrl: `${this.markers[i].ref_icon[type]}`,
                iconSize: [32, 32]
              })
            }

            this.markers[i].alarm =
              parseInt(data.alarm) == 0
                ? '-'
                : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
                    .label
          } else if (data.type === 'door') {
            this.markers[i].serverTime = this.secondToDateTime(data.time)
            this.markers[i].door = data.door

            if (this.markers[i].ref_icon) {
              this.markers[i].icon = L.icon({
                // iconUrl: `${this.$api.base_url}/uploads/icon/${this.markers[i].ref_icon[type]}`,
                iconUrl: `${this.markers[i].ref_icon[type]}`,
                iconSize: [32, 32]
              })
            }

            this.markers[i].alarm =
              parseInt(data.alarm) == 0
                ? '-'
                : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
                    .label
          } else if (data.type === 'temperature') {
            this.markers[i].serverTime = this.secondToDateTime(data.time)
            this.markers[i].temperature = data.temperature
            this.markers[i].door = data.door

            if (this.markers[i].ref_icon) {
              this.markers[i].icon = L.icon({
                // iconUrl: `${this.$api.base_url}/uploads/icon/${this.markers[i].ref_icon[type]}`,
                iconUrl: `${this.markers[i].ref_icon[type]}`,
                iconSize: [32, 32]
              })
            }

            this.markers[i].alarm =
              parseInt(data.alarm) == 0
                ? '-'
                : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
                    .label
          }

          this.markers[i].alarm =
            parseInt(data.alarm) == 0
              ? '-'
              : this.list_alarm.find((e) => e.value === parseInt(data.alarm))
                  .label
        }
      }

      this.ws.onclose = (e) => {
        this.isConnect = 'close'

        if (this.$route.name == 'tracking') {
          if (this.isConnect == 'close') {
            setTimeout(() => {
              this.connect()
            }, 10000)
          }

          console.log(
            'Socket is closed. Reconnect will be attempted in 10 second.'
          )
        }
      }

      this.ws.onerror = (err) => {
        this.isConnect = 'close'
        console.error('Socket encountered error: ', 'Closing socket')
        this.ws.close()
      }
    },

    getAddress(latlng, target, index = 0) {
      // if (!this[target][index].address) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: latlng.lat,
            longitude: latlng.lon
          }
        })
        .then((res) => {
          this[target][index].address = res.data.message
          this.showAddress = true
          // this.showAddress = !this.showAddress
        })
      // }
    },

    showPolygone(params) {
      if (params === 'poi') {
        this.clicks++
        if (this.clicks === 1) {
          this.timer = setTimeout(() => {
            this.show_hide[params] = !this.show_hide[params]
            this.isPermanentPoi = false
            this.clicks = 0

            if (this.show_hide[params] == true)
              this.show_hide_color[params] = 'primary'
            else this.show_hide_color[params] = 'white'
          }, 700)
        } else {
          clearTimeout(this.timer)
          this.show_hide[params] = !this.show_hide[params]
          this.isPermanentPoi = true
          this.clicks = 0

          if (this.show_hide[params] == true)
            this.show_hide_color[params] = 'primary'
          else this.show_hide_color[params] = 'white'
        }
      } else {
        this.show_hide[params] = !this.show_hide[params]
        if (this.show_hide[params] == true)
          this.show_hide_color[params] = 'primary'
        else this.show_hide_color[params] = 'white'
      }
    },

    streetView() {
      let index = this.last_map_position.length
      if (index > 0) {
        let lat = this.last_map_position[index - 1].lat
        let lon = this.last_map_position[index - 1].lon

        let url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat}%2C${lon}&heading=-45&pitch=38&fov=80`

        window.open(
          url,
          '_blank',
          'toolbar=1, scrollbars=1, resizable=1, width=' +
            800 +
            ', height=' +
            500
        )
      } else {
        this.$vs.notify({
          title: 'Attention !',
          text: 'Vehicle not selected',
          color: 'warning',
          position: 'top-right'
        })
      }
    },

    openGoogleMap() {
      let index = this.last_map_position.length
      if (index > 0) {
        let lat = this.last_map_position[index - 1].lat
        let lon = this.last_map_position[index - 1].lon

        let url = `https://www.google.com/maps/@${lat},${lon},18z?hl=en-US&entry=ttu`

        window.open(url)
      } else {
        this.$vs.notify({
          title: 'Attention !',
          text: 'Vehicle not selected',
          color: 'warning',
          position: 'top-right'
        })
      }
    },

    get_alarm() {
      this.$http
        .get(`${this.$api.endpoint}/ref_alert/list_alarm`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          const data = res.data.message.data

          this.list_alarm = data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getPoiIcon() {
      this.$http
        .get(`${this.$api.endpoint}/poi_icon/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.iconList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    create_poi(item) {
      this.poi_add.icon = ''
      this.poi_add.name = ''

      setTimeout(() => {
        this.popUpAddPoi = !this.popUpAddPoi

        let latlon = item.latLon.split(', ')
        this.poi_add.lat = latlon[1]
        this.poi_add.lon = latlon[0]
        this.poi_add.type = 0
        this.poi_add.geom = `POINT(${latlon[0]} ${latlon[1]})`
      }, 1000)
    },

    submit_poi() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/poi/add`

      this.$http
        .post(
          url,
          {
            user_id: this.actor.id,
            name: this.poi_add.name,
            type: this.poi_add.type,
            lon: this.poi_add.lon,
            lat: this.poi_add.lat,
            geom: this.poi_add.geom,
            icon_id: this.poi_add.type === 0 ? this.poi_add.icon.value : 0
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.popUpAddPoi = false

          this.getPoiList()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    },

    monitoringMode() {
      let route = this.$router.resolve({ path: '/monitoring' })
      window.open(route.href, '_blank')
      // console.log(this.treeData)
    },

    search_proses(e) {
      if (e !== undefined) {
        if (e.key === 'Enter') {
          this.keyword = ''
          this.search(this.temp_keyword)
        }
      } else {
        this.keyword = ''
        this.search(this.temp_keyword)
      }
    },

    reset_time(item, index) {
      this.loading_reset_time = true
      this.$http
        .post(
          `${this.$api.endpoint}/tracking/reset_time`,
          {
            imei: item.imei
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          let data = res.data.message.data

          this.markers[index].time = data.time
          this.markers[index].serverTime = data.server_time

          this.loading_reset_time = false

          this.notify = 'Reset Time GPS Successfully'
          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.loading_reset_time = false
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/tree.scss';
</style>
